import React from 'react'

const OptionBox = ({ children, selected ,onClick}) => {

    const baseStyle = {
        height:"fit-content",
        border: "1px solid transparent",
        borderRadius: "8px", // rounded-full equivalent
        padding: "2px 7px", // similar to Tailwind's px-4 py-2
        cursor: "pointer",
        display: "inline-block", // to ensure it takes the correct shape
        textAlign: "center",
        transition: "background-color 0.2s ease, color 0.2s ease", // smooth transition
      };
    
      // Define styles for selected and unselected
      const selectedStyle = selected
        ? {
            backgroundColor: "#007bff", // Blue background (selected)
            color: "#fff", // White text (selected)
          }
        : {
            backgroundColor: "#e7f3ff", // Lighter blue background (unselected)
            color: "#007bff", // Blue text (unselected)
          };

  return (
    <div 
    style={{
        ...baseStyle,
        ...selectedStyle,
      }}
    onClick={onClick}
    >{children}</div>
  )
}

export default OptionBox